export const en = {
  languageName: "English",
  strings: {
    "language.switchLabel": "Language",
    "language.english": "English",
    "language.chinese": "中文",
    "home.hero.title": "Peanut FPV | Blackbox Explorer Mirror",
    "welcome.openFile": "Open log file/video",
    "tooltip.openFile": "Start by opening a log or video file",
    "placeholder.jumpTime": "Enter a time to jump to",
    "loading.file": "Trying to load file {fileName}...",
    "version.current": "You are using version {version}",
    "error.unsupportedBrowser": "Your browser does not support the APIs required for reading log files.",
    "error.localVideoUnsupported": "Sorry, your web browser doesn't support showing videos from your local computer.",
    "error.videoLoad": "Error while loading the video.",
    "error.chromiumVideoExport": "Video export is only supported in Chromium based browsers.",
    "workspace.upgrading": "Old Workspace format. Upgrading...",
    "workspace.loaded": "Workspaces Loaded",
    "workspace.empty": "<empty>",
    "workspace.editName": "Edit Workspace Name",
    "workspace.saveHere": "Save current graph setup to this Workspace",
    "graph.chooseField": "(choose a field)",
    "graph.graph": "Graph",
    "graph.removeGraph": "Remove graph",
    "graph.axisLabel": "Axis label",
    "graph.fields": "Fields:",
    "graph.name": "Name",
    "graph.smooth": "Smooth",
    "graph.expo": "Expo",
    "graph.line": "Line",
    "graph.color": "Color",
    "graph.minimum": "Minimum",
    "graph.maximum": "Maximum",
    "graph.addField": "Add field",
    "videoExport.title": "Export video",
    "videoExport.rendering": "Rendering video...",
    "videoExport.complete": "Video rendering complete!",
    "videoExport.result": "Rendered {frameCount} frames in {duration}",
    "videoExport.calculating": "Calculating...",
    "settings.notEnoughMotors": "Error, you have selected a craft type that required more motors than are available in the log; There are only a maximum of {available} motors in the log file; the selection you have chosen requires {required} motors.",
    "settings.motor": "Motor {number}",
    "home.blackbox.builtIn": "The Blackbox feature is built in to <a href=\"https://github.com/betaflight/betaflight/releases\" target=\"_blank\" rel=\"noopener noreferrer\">Betaflight</a> and is supported on most modern flight controllers (HAKRC F405, SpeedyBee F405, Mamba F722, etc.).",
    "home.blackbox.docs": "To get started with Blackbox recording, read <a href=\"https://github.com/betaflight/betaflight/blob/master/docs/Blackbox.md\" target=\"_blank\" rel=\"noopener noreferrer\">Betaflight's Blackbox feature documentation</a>.",
    "home.blackbox.viewerDocs": "Already have a log recorded? View <a href=\"https://github.com/betaflight/blackbox-tools/blob/master/Readme.md\" target=\"_blank\" rel=\"noopener noreferrer\">the documentation for this log viewer</a> for details on how to best use this tool.",
    "home.blackbox.bugs": "If you believe you've found a bug in this viewer (e.g. the viewer crashes upon attempting to open a log file), or you have a suggestion, please add it to <a href=\"https://github.com/betaflight/blackbox-log-viewer/issues\" target=\"_blank\" rel=\"noopener noreferrer\">the viewer's GitHub bug tracker</a>.",
    "home.tuning.intro": "The Blackbox can deliver insights on your flight performance that will allow you to tune variables such as your PIDs and low-pass filter settings.",
    "home.tuning.resources": "For help and instructions on how to tune your craft, please read some of these resources:",
    "home.tuning.link.pidStart": "Mini quad PID tuning from start to finish",
    "home.tuning.link.helpThread": "Blackbox log analyzation/help thread",
    "home.tuning.link.betaflightPid": "Betaflight's PID tuning documentation",
    "home.tuning.link.support": "Betaflight support topic",
    "home.tuning.link.originalViewer": "Blackbox announcement topic (original viewer)",
    "home.tuning.link.enhancedViewer": "Enhanced Blackbox announcement topic (this viewer)",
    "home.tuning.byJoshua": "by Joshua Bardwell on RCGroups.com",
    "home.tuning.onRcgroups": "on RCGroups.com",
    "home.tools.decode": "If you want to analyze your logs with your own mathematics package (such as Matlab) you can use the separate <a href=\"https://github.com/betaflight/blackbox-tools/\" target=\"_blank\" rel=\"noopener noreferrer\">blackbox_decode tool</a> to convert your log file into a CSV file for analysis.",
    "home.tools.video": "If you want to share your log as a video, you can use the \"export video\" button at the top to render a WebM video, or use the commandline <a href=\"https://github.com/betaflight/blackbox-tools/\" target=\"_blank\" rel=\"noopener noreferrer\">blackbox_render tool</a> to turn your log into a series of PNG files, or use a screen recording tool to record the playback of this log viewer.",
  },
  text: {},
  fieldTerms: {},
};
